import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Navbar from './sub/navbar';
import Helper from '../Helper';
const MainPage = () => {
  const navigate = useNavigate();
    useEffect(() => {
      // Get the token from sessionStorage
  
  
      if (!Helper.gettoken()) {
        navigate('/login');
        return;
      }
      if(Helper.getuserrole()=="user"){
        navigate('/TransportList');
        return;
      }
      if(Helper.getuserrole()=="user"){
        navigate('/TransportAccountList');
        return;
      }
      if(Helper.getuserrole()=="billing"){
        navigate('/TransportBillingList');
        return;
      }
      if(Helper.getuserrole()=="admin"){
       // navigate('/Dashboard');
        return;
      }

    }, []);
  
  return (
    <>
      <Navbar />
    <div style={{ textAlign: 'center', marginTop: '50px' }}>

    </div>
    </>
  );
};

export default MainPage;
